import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
var _excluded = ["type", "children", "name", "defaultValue", "defaultChecked", "value", "checked", "disabled", "className", "onChange"];
import * as React from 'react';
import clsx from 'clsx';
import Pill from '../../Pill';
var styles = {
  "root": "TogglePill-root_zPTX9",
  "input": "TogglePill-input_aq6FH"
};
/**
 * Custom themes for TooglePill.
 */
var themes = {
  default: {
    color: 'anthracite',
    backgroundColor: 'transparent',
    borderColor: 'grey',
    hoverBorderColor: 'blue',
    bordered: true,
    interactive: true
  },
  checked: {
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'blue',
    bordered: true,
    interactive: true
  },
  disabled: {
    color: 'grey-dark',
    backgroundColor: 'transparent',
    bordered: true,
    borderColor: 'grey'
  }
};
function computeTheme(props) {
  if (props.disabled && !props.checked) {
    return themes.disabled;
  }
  if (props.disabled && props.checked) {
    return _objectSpread(_objectSpread({}, themes.disabled), {}, {
      backgroundColor: 'grey'
    });
  }
  if (props.checked) {
    return themes.checked;
  }
  return themes.default;
}
function TogglePill(props) {
  var _props$type = props.type,
    type = _props$type === void 0 ? 'radio' : _props$type,
    children = props.children,
    name = props.name,
    defaultValue = props.defaultValue,
    defaultChecked = props.defaultChecked,
    value = props.value,
    checked = props.checked,
    disabled = props.disabled,
    className = props.className,
    onChange = props.onChange,
    extraProps = _objectWithoutProperties(props, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Pill, _extends({
      tagName: "label",
      theme: computeTheme(props),
      className: clsx(styles.root, className)
    }, extraProps), /*#__PURE__*/React.createElement("input", {
      name: name,
      type: type,
      autoComplete: "off",
      defaultValue: defaultValue,
      defaultChecked: defaultChecked,
      value: value,
      checked: checked,
      disabled: disabled,
      onChange: onChange,
      className: styles.input
    }), children)
  );
}
export default TogglePill;